import { createSelector } from 'reselect'
import get from 'lodash/get'
import { HOME_CATEGORY_ID } from './content'

export const boardView = state => state.boardView

export const currentBoard = createSelector(
  boardView,
  (boardView) => get(boardView, 'currentBoard', {})
)

export const currentBoardId = createSelector(
  currentBoard, (currentBoard) => get(currentBoard, 'id')
)

export const isCurrentBoardV3 = createSelector(
  currentBoard, (currentBoard) => currentBoard?.is_v3_live
)

export const boardContent = createSelector(
  boardView,
  currentBoardId,
  (boardView, currentBoardId) => boardView[currentBoardId]
)

export const activeTab = createSelector(
  boardContent, (boardContent) => get(boardContent, 'activeTab')
)

export const actionPermissions = createSelector(
  boardContent,
  activeTab,
  (boardContent, activeTab) => get(boardContent, [activeTab, 'actionPermissions'])
)

export const downloadAnalyticsPermission = createSelector(
  boardView, (boardView) => get(boardView.currentBoard.permissions, 'download_analytics')
)

export const boardCategoriesIds = createSelector(
  boardView,
  currentBoardId,
  (boardView, currentBoardId) => get(boardView, [currentBoardId, 'content', 'categoriesIds'])
)

export const selectedCategoryId = createSelector(
  boardView,
  currentBoardId,
  (boardView, currentBoardId) => {
    return get(boardView, [currentBoardId, 'content', 'selectedCategoryId'])
  }
)

export const getSelectedCategories = createSelector(
  selectedCategoryId,
  (selectedCategoryId) => {
    return selectedCategoryId === HOME_CATEGORY_ID ? [] : [selectedCategoryId]
  }
)

export const getEmailCampaigns = createSelector(
  boardContent,
  boardContent => get(boardContent, 'emailCampaigns')
)

const currentItem = ({ items, boardView }, { itemId }) => {
  return get(items, ['data', boardView.currentBoard.id, itemId], {})
}

export const makeGetItem = () => {
  return createSelector(
    [selectedCategoryId, currentItem],
    (selectedCategoryId, currentItem) => {
      const publicLink = get(currentItem.public_links, selectedCategoryId)
      return { ...currentItem, public_link: publicLink }
    }
  )
}
